const initialState = {
}

export const thirdArrayReducer = (state = initialState, action) => {
    switch (action.types) {
        default:
            return state;
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/thirdArrayReducer.js